import React from 'react'
import DialogContent from '@mui/material/DialogContent';
import { createDraggablePaperComponent } from '../../dialog/DraggablePaper';
import ProjectListContainer from '../../../../containers/common/form/modal/ProjectListContainer'
import BootstrapDialog, { BootstrapDialogTitle } from '../../dialog/BootstrapDialog'


const PaperComponent = createDraggablePaperComponent('draggable-project-dialog');

const ProjectModal = ({ title, open, handleClose, selectedProject }) => {
    return (
        <BootstrapDialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-project-dialog"
            fullWidth={true}
            maxWidth="lg"
        >
            <BootstrapDialogTitle style={{ cursor: 'move' }} id="draggable-project-dialog" onClose={handleClose}>
                {title}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <ProjectListContainer handleClose={handleClose} selectedProject={selectedProject} />
            </DialogContent>
        </BootstrapDialog>
    )
}

export default ProjectModal